import { useMemo } from 'react';

import { LeftFilterTitleCell } from '../components/LeftFilterVersionTitleCell';

export interface ILeftFilterVersColumnsItem {
    id: number;
    options: {
        level: number;
    };
    rows?: any;
    title: string;
}

export const useTableTreeLeftFilterVersColumns = () =>
    useMemo(
        () => [
            {
                title: 'Виды строительства',
                accessor: 'title',
                align: 'left',
                renderCell: (item: ILeftFilterVersColumnsItem) => <LeftFilterTitleCell item={item} />,
            },
        ],
        [],
    );
